import { render } from "./BaseKpiChart.vue?vue&type=template&id=db27e0c6&scoped=true&ts=true"
import script from "./BaseKpiChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseKpiChart.vue?vue&type=script&setup=true&lang=ts"

import "./BaseKpiChart.vue?vue&type=style&index=0&id=db27e0c6&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db27e0c6"],['__file',"resources/js/views/home/components/shared/BaseKpiChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db27e0c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db27e0c6', __exports__)) {
    console.log('reload')
    api.reload('db27e0c6', __exports__)
  }
  
  module.hot.accept("./BaseKpiChart.vue?vue&type=template&id=db27e0c6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('db27e0c6', render)
  })

}


export default __exports__